export namespace CacheKeys {
  export enum UserPreferences {
    ActiveOrgId = "sds:orgs:activeOrgId",
  }
}
